//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgContact } from '../icons/Contact';

export function ContactIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgContact} data-qa="ContactIcon">
      <svg />
    </SvgIcon>
  );
}
